import { v4 as uuidv4 } from 'uuid'

export const _USER = {
  username: '',
  firstName: '',
  lastName: '',
  profileImage: '',
  roles: [],
  broadcasts: [],
  userGroups: [],
}

export const _ROLE = {
  name: '',
  modifiedBy: '',
  modifiedAt: '',
  permissions: [],
  users: [],
}

export const _USER_GROUP = {
  name: '',
  modifiedBy: '',
  modifiedAt: '',
  users: [],
  broacastTemplates: [],
}

export const _TEMPLATE_FILE = {
  name: '',
  tags: [],
  modifiedBy: '',
  modifiedAt: '',
  type: '',
  content: '',
  broacastTemplates: [],
}

export const _TAG = {
  name: '',
}

export const _INPUT_FIELD = {
  name: '',
  tags: [],
  type: '',
  modifiedBy: '',
  modifiedAt: '',
  options: [],
  broacastTemplates: [],
  required: false,
}

export const _PLACEHOLDER_MAPPING = {
  name: '',
  tags: [],
  modifiedBy: '',
  modifiedAt: '',
  key: '',
  value: '',
}

export const _BSFT_EMAIL_CONFIG = {
  name: '',
  tags: [],
  modifiedBy: '',
  modifiedAt: '',
  broacastTemplates: [],
  adapterUuid: '',
  segmentUuid: '',
  userCount: 0,
  userCountLastUpdated: '',
  fromName: '',
  utmSource: '',
}

export const _BSFT_SMS_CONFIG = {
  name: '',
  tags: [],
  fromName: '',
  modifiedBy: '',
  modifiedAt: '',
  broacastTemplates: [],
  adapterUuid: '',
  segmentUuid: '',
  userCount: 0,
  userCountLastUpdated: '',
  rebrandlyDomain: '',
}

export const _WP_CONFIG = {
  name: '',
  tags: [],
  modifiedBy: '',
  modifiedAt: '',
  broacastTemplates: [],
  site: '',
  authorId: '',
  categoryIds: [],
  pubCodeIds: [],
  portfolio: '',
}

export const _CONTENTFUL_CONFIG = {
  name: '',
  tags: [],
  modifiedBy: '',
  modifiedAt: '',
  site: '',
  broacastTemplates: [],
  authorId: '',
  categoryId: '',
  publicationId: '',
  portfolio: '',
  pro: false,
  lifetime: false,
}

export const _BROADCAST_TEMPLATE = {
  name: '',
  displayName: '',
  tags: [],
  modifiedBy: '',
  modifiedAt: '',
  defaultContent: '',
  defaultTestEmail: '',
  defaultOptions: [],
  itemCode: '',
  emailEnabled: false,
  smsEnabled: false,
  webEnabled: false,
  webDelay: false,
  keywordsEnabled: false,
  testEnabled: false,
  inputFields: [],
  emailBroadcasts: [],
  emailTemplate: null,
  smsBroadcasts: [],
  webPosts: [],
  userGroups: [],
  broadcasts: [],
  externalFetchTemplates: [],
  iterableEmail: {
    templateId: 0,
    listIds: [],
    suppressionListIds: [],
    sendMode: 'ProjectTimeZone',
    startTimeZone: 'America/New_York',
  },
  defaultTestEmailAddress: '',
}

export const _BROADCAST = {
  name: '',
  tags: [],
  modifiedBy: '',
  modifiedAt: '',
  createdBy: '',
  createdAt: '',
  broadcastTemplate: '',
  options: [],
  broadcastContent: {},
  status: {},
}

export const _ITERABLE_TEMPLATE = {
  name: '',
  fromEmail: '',
  fromName: '',
  subject: '',
  html: '<p>{{unsubscribeUrl}}</p>',
  clientTemplateId: uuidv4(),
  messageTypeId: null,
  creatorUserId: '',
  dataFeedIds: [],
  cacheDataFeed: false,
  mergeDataFeedContext: false,
}

export const _ITERABLE_CONFIG = {
  name: '',
  tags: [],
  type: '',
  templateId: null,
  listIds: [],
  suppressionListIds: [],
  sendMode: 'ProjectTimeZone',
  startTimeZone: '',
  broadcastTemplates: [],
  campaignPrefix: '',
  templateFile: null,
}

export const _WORDPRESS_BROADCAST_OPTIONS = [
  { key: 'wordpress-objectives', value: '' },
  { key: 'wordpress-psychologies', value: '' },
  { key: 'wordpress-sectors', value: '' },
  { key: 'wordpress-featured-image', value: '' },
]
